import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { useLanguage } from "../context/LanguageContext";
import { useT } from "../i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BlogPost = () => {
  const { slug } = useParams();
  const { lang } = useLanguage();
  const t = useT(lang);
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/blog/${slug}`).then((r) => {
      setPost(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="container-wc py-32 text-dim">Loading...</div>;
  if (!post) return <div className="container-wc py-32 text-dim">Not found</div>;

  return (
    <article className="py-24 md:py-32">
      <div className="container-wc max-w-3xl">
        <Link to="/blog" data-testid="blog-back" className="text-gold text-sm uppercase tracking-widest hover:text-white transition-colors">
          {t.blog.back}
        </Link>
        <h1 className="h-display text-4xl md:text-6xl mt-6 mb-4">{lang === "el" ? post.title_el : post.title_en}</h1>
        <div className="flex items-center gap-3 text-sm text-dim mb-10">
          <span>{post.author}</span>
          <span>·</span>
          <span>{new Date(post.created_at).toLocaleDateString(lang === "el" ? "el-GR" : "en-GB")}</span>
        </div>
        {post.cover_image && (
          <div className="aspect-[16/9] overflow-hidden border border-goldSoft mb-12">
            <img src={post.cover_image} alt="" className="w-full h-full object-cover img-moody" />
          </div>
        )}
        <div className="prose prose-invert max-w-none text-lg leading-relaxed text-[#E8E8E0] whitespace-pre-line">
          {lang === "el" ? post.content_el : post.content_en}
        </div>
      </div>
    </article>
  );
};

export default BlogPost;
